import { render, staticRenderFns } from "./company-view-card.vue?vue&type=template&id=bbe0ec28&scoped=true"
import script from "./company-view-card.vue?vue&type=script&lang=js"
export * from "./company-view-card.vue?vue&type=script&lang=js"
import style0 from "./company-view-card.vue?vue&type=style&index=0&id=bbe0ec28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0ec28",
  null
  
)

export default component.exports